import request from "@/utils/request";

export function queryListForShipmentToPlatform(query) {
  return request({
    url: "/ntocc-tms-api/remitDefinite/queryListForShipmentToPlatform",
    method: "get",
    params: query
  });
}

// /ntocc-tms-api/remitDefinite/queryListForPlatformToDrive
export function queryListForPlatformToDrive(query) {
  return request({
    url: "/ntocc-tms-api/remitDefinite/queryListForPlatformToDrive",
    method: "get",
    params: query
  });
}

export function singlePayment(data) {
  return request({
    url: "/ntocc-tms-api/finance/singlePayment",
    method: "post",
    params: data
  });
}
export function translateAccount(query) {
  return request({
    url: "/ntocc-tms-api/collectionAccountCheck/translateAccount",
    method: "get",
    params: query
  });
}
export function collectionAccountCheck(detailCodes, billType) {
  return request({
    url: "/ntocc-tms-api/collectionAccountCheck",
    method: "post",
    params: {
      detailCodes: detailCodes,
      billType: billType
    }
  });
}
export function collectionDetail(code) {
  return request({
    url: `ntocc-tms-api/collectionAccountCheck/${code}`,
    method: "get"
  });
}
export function collectionPost(query) {
  return request({
    url: "/ntocc-tms-api/collectionAccountCheck",
    method: "get",
    params: query
  });
}
export function page4Review(query) {
  return request({
    url: "/ntocc-tms-api/collectionAccountCheck/page4Review",
    method: "get",
    params: query
  });
}
export function auditPut(data) {
  return request({
    url: "/ntocc-tms-api/collectionAccountCheck/audit",
    method: "put",
    params: data
  });
}
export function collectionPut(data) {
  return request({
    url: "/ntocc-tms-api/collectionAccountCheck/collection",
    method: "put",
    params: data
  });
}
export function defaultApi(query) {
  return request({
    url: "/ntocc-tms-api/orderDefaultInfo/default",
    method: "get",
    params: query
  });
}

export function DefaultSubmitOrder(data) {
  return request({
    url: "/ntocc-tms-api/orderDefaultInfo/submitOrder",
    method: "post",
    data
  });
}

export function DefaultUpdateOrder(data) {
  return request({
    url: "/ntocc-tms-api/orderDefaultInfo/updateOrder",
    method: "put",
    data
  });
}

// 查询客户余额
export function balance(code) {
  return request({
    url: `/ntocc-tms-api/collectionAccountCheck/balance`,
    method: "get"
  });
}

// ctms查询收款对账 xuel
export function ctmstranslateAccount(data) {
  return request({
    url: "/ntocc-ctms-api/ctmsCollectionAccountCheck/translateAccount",
    method: "get",
    params: data
  });
}

// ctms生成对账单 xuel
export function ctmscollectionAccountCheck(detailCodes) {
  return request({
    url: "/ntocc-ctms-api/ctmsCollectionAccountCheck",
    method: "post",
    params: {
      detailCodes: detailCodes
    }
  });
}
// ctms查询对账列表 xuel
export function ctmscollectionPost(query) {
  return request({
    url: "/ntocc-ctms-api/ctmsCollectionAccountCheck",
    method: "get",
    params: query
  });
}

// ctms查询对账列表详情 xuel
export function ctmsCollectionDetail(code) {
  return request({
    url: `/ntocc-ctms-api/ctmsCollectionAccountCheck/${code}`,
    method: "get"
  });
}

export function getCheckList(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/settlementlist",
    method: "post",
    data
  });
}

export function settlementlistnew(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/settlementlistnew",
    method: "post",
    data
  });
}

// 合同管理
export function contractCompanyList(data) {
  return request({
    url: "/ntocc-basic-api/asign/contract/company/list",
    method: "post",
    data
  });
}

//人脸识别企业法人认证(管理员)
export function faceidcard(query) {
  return request({
    // url: `/ntocc-basic-api/app/asign/company/faceidcard`,
    url: `/ntocc-basic-api/app/asign/company/faceidcard`,
    method: "get",
    params: query
  });
}

// 查询人脸识别结果
export function addauthbyidcard(query) {
  return request({
    url: `/ntocc-basic-api/app/asign/company/addauthbyidcard`,
    method: "get",
    params: query
  });
}

// 获取信用代码列表
export function authfailedlist(query) {
  return request({
    url: `/ntocc-basic-api/app/asign/company/authfailedlist`,
    method: "get",
    params: query
  });
}

// 导出全部
export function settlementlistExport(data) {
  return request({
    url: `/ntocc-tms-api/orderDetail/settlementlistExport`,
    method: "post",
    data
  });
}

// 获取打款信息
export function reversetransfer(query) {
  return request({
    url: `/ntocc-basic-api/app/asign/company/reversetransfer`,
    method: "get",
    params: query
  });
}

// 确认打款信息
export function reversetransfercheck(query) {
  return request({
    url: `/ntocc-basic-api/app/asign/company/reversetransfercheck`,
    method: "get",
    params: query
  });
}

export function settlementlistshipper(data) {
  return request({
    url: "/ntocc-tms-api/orderDetail/settlementlistshipper",
    method: "post",
    data
  });
}
